import React, { useEffect, useState } from "react";
import { firebaseFirestore } from "./firebase";

interface Counts {
  userCount: number;
  requestCount: number;
  letterCount: number;
  reportCount: number;
}

function Statistics() {
  const [counts, setCounts] = useState<Counts>({
    userCount: 0,
    requestCount: 0,
    letterCount: 0,
    reportCount: 0,
  });

  useEffect(() => {
    const fetchCounts = async () => {
      const usersSnapshot = await firebaseFirestore.collection("users").get();
      const requestsSnapshot = await firebaseFirestore.collection("requests").get();
      const lettersSnapshot = await firebaseFirestore.collection("letters").get();
      const reportsSnapshot = await firebaseFirestore.collection("reports").get();

      setCounts({
        userCount: usersSnapshot.size,
        requestCount: requestsSnapshot.size,
        letterCount: lettersSnapshot.size,
        reportCount: reportsSnapshot.size,
      });
    };

    fetchCounts();
  }, []);

  return (
    <div className="navbar is-light">
      <div className="navbar-item">
        <strong>Users</strong>: {counts.userCount}
      </div>
      <div className="navbar-item">
        <strong>Requests</strong>: {counts.requestCount}
      </div>
      <div className="navbar-item">
        <strong>Letters</strong>: {counts.letterCount}
      </div>
      <div className="navbar-item">
        <strong>Reports</strong>: {counts.reportCount}
      </div>
    </div>
  );
}

export default Statistics;
